const ROOT_USER_ID = Symbol("ROOT_USER_ID");
export default ROOT_USER_ID;



// WEBPACK FOOTER //
// ./src/RootUser.js